import Ajv from 'ajv'
import * as gameSceneSchema from '../../../schema/gameScene.schema.json'
import * as levelSchema from '../../../schema/level.schema.json'
import * as inventorySchema from '../../../schema/inventory.schema.json'
import * as inventoryCombinationsSchema from '../../../schema/inventoryCombinations.schema.json'
import * as dialogSchema from '../../../schema/dialog.schema.json'
import { GameSceneManifestJson } from './GameSceneJson'
import { LevelManifestJson } from './LevelJson'
import { InventoryItemsManifestJson } from './InventoryItemsManifestJson'
import { InventoryCombinationsManifestJson } from './InventoryCombinationsJson'
import { DialogManifestJson } from './DialogJson'

const ajv = new Ajv()

ajv.addSchema(gameSceneSchema, 'gameScene')
ajv.addSchema(levelSchema, 'level')
ajv.addSchema(inventorySchema, 'inventory')
ajv.addSchema(inventoryCombinationsSchema, 'inventoryCombinations')
ajv.addSchema(dialogSchema, 'dialog')

// this compiles and caches the schema validator function
export const validateGameScene = ajv.getSchema<GameSceneManifestJson>('gameScene')
export const validateLevel = ajv.getSchema<LevelManifestJson>('level')
export const validateInventory = ajv.getSchema<InventoryItemsManifestJson>('inventory')
export const validateInventoryCombinations = ajv.getSchema<InventoryCombinationsManifestJson>('inventoryCombinations')
export const validateDialog = ajv.getSchema<DialogManifestJson>('dialog')
